import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_gen-x-move/artifacts/9o3bqwfl_A262EFED-8133-4480-9216-7E1E7DD071FD.png";

const MarqueeRibbon = () => {
  const items = [
    "Kora Club",
    "Movimento que te define",
    "Lista VIP aberta",
    "Moda ativa feminina",
    "Brasil",
  ];
  const row = [...items, ...items, ...items, ...items];

  return (
    <div
      data-testid="hero-marquee"
      className="absolute top-0 left-0 right-0 z-20 bg-kora-black/85 backdrop-blur-sm border-b border-kora-gold/30 overflow-hidden py-3"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-mono-label text-kora-gold-light flex items-center gap-6 px-8"
          >
            {t}
            <span className="text-kora-gold/60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export const Hero = () => {
  const scrollTo = (id) => {
    document
      .querySelector(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      id="hero"
      data-testid="section-hero"
      className="hero-root"
    >
      {/* 1. Background image — direct child, absolutely positioned */}
      <img
        src={HERO_IMG}
        alt=""
        data-testid="hero-image"
        className="hero-bg-image"
        loading="eager"
        aria-hidden="true"
      />

      {/* 2. Dark overlay layers for text legibility */}
      <div className="hero-overlay" aria-hidden="true" />

      {/* 3. Marquee ribbon */}
      <MarqueeRibbon />

      {/* 4. Text content wrapper — relative + z-index: 1 */}
      <div className="hero-content">
        <p
          data-testid="hero-eyebrow"
          className="font-mono-label text-kora-gold-light mb-8 hero-line"
          style={{ animationDelay: "0.1s" }}
        >
          ✦ Em breve — Brasil
        </p>

        <h1
          data-testid="hero-headline"
          className="font-display text-[40px] sm:text-6xl lg:text-[96px] xl:text-[120px] leading-[0.95] tracking-tight text-kora-cream max-w-5xl"
        >
          <span className="block hero-line" style={{ animationDelay: "0.5s" }}>
            Você não para.
          </span>
          <span
            className="block italic text-gold-gradient hero-line"
            style={{ animationDelay: "0.9s" }}
          >
            Sua roupa
          </span>
          <span className="block hero-line" style={{ animationDelay: "1.3s" }}>
            também não.
          </span>
        </h1>

        <p
          data-testid="hero-sub"
          className="hero-line mt-6 md:mt-10 max-w-xl text-sm md:text-lg leading-relaxed text-kora-cream/90"
          style={{ animationDelay: "1.7s" }}
        >
          Moda ativa premium para a mulher que nunca parou de se mover. Da
          quadra de tênis ao café da tarde — sem trocar de roupa, sem abrir
          mão do estilo.
        </p>

        <div
          data-testid="hero-actions"
          className="hero-line mt-8 md:mt-12 flex flex-col items-center gap-3"
          style={{ animationDelay: "2.1s" }}
        >
          <div className="flex flex-col sm:flex-row gap-5 items-center">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("#vip")}
              className="btn-outline-hero"
            >
              Quero acesso antecipado
              <span className="arrow">→</span>
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("#colecao")}
              className="font-mono-label text-kora-cream/85 hover:text-kora-gold-light transition-colors link-underline"
            >
              Ver a Coleção
            </button>
          </div>
          <p
            data-testid="hero-cta-offer"
            className="text-sm sm:text-base text-kora-cream/70 leading-snug max-w-md mt-2"
          >
            ✦ Entre agora e garanta 15% off na primeira coleção.
          </p>
        </div>

        <button
          data-testid="hero-scroll-cue"
          onClick={() => scrollTo("#manifesto")}
          className="hero-scroll-cue hero-line"
          style={{ animationDelay: "2.5s" }}
        >
          <span className="font-mono-label">Role para descobrir</span>
          <ArrowDown size={16} className="animate-bounce" />
        </button>
      </div>
    </div>
  );
};
